// Signed-in account menu: a dropdown on desktop, a full-screen overlay on
// mobile. The body class drives the mobile scroll lock (see _header.scss).
export default function setupAccountMenu() {
  const root = document.querySelector<HTMLElement>(".account-menu")
  if (!root) return

  const toggle = root.querySelector<HTMLButtonElement>(".account-menu-toggle")
  if (!toggle) return

  const onDocumentClick = (event: MouseEvent) => {
    if (!root.contains(event.target as Node)) setOpen(false)
  }

  const onKeydown = (event: KeyboardEvent) => {
    if (event.key === "Escape") {
      setOpen(false)
      toggle.focus()
    }
  }

  const setOpen = (open: boolean) => {
    root.classList.toggle("open", open)
    toggle.setAttribute("aria-expanded", String(open))
    document.body.classList.toggle("mobile-account-menu-opened", open)

    if (open) {
      document.addEventListener("click", onDocumentClick)
      document.addEventListener("keydown", onKeydown)
    } else {
      document.removeEventListener("click", onDocumentClick)
      document.removeEventListener("keydown", onKeydown)
    }
  }

  toggle.addEventListener("click", () => {
    setOpen(!root.classList.contains("open"))
  })
}
